<script lang="ts" setup>

import { ref,onMounted } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import axiosInstance from '@/plugins/axios';
import router from '@/router';


const globalMessages = ref([]);
const acknowledgedBy = ref([]);
const showUsersDialog = ref(false);
const users = ref([]);

const getGlobalMessages = async () => {
    try {
        const response = await axiosInstance.get('/admin/getGlobalMessages');
        globalMessages.value = response.data;
    } catch (error) {
        console.log(error);
    }
};

const getAllUsers = async () => {
    try {
        const response = await axiosInstance.get('/user');
        users.value = response.data;
    } catch (error) {
        console.log(error);
    }
};

const showUsers = (users: any) => {
    acknowledgedBy.value = users;
    showUsersDialog.value = true;
};

const getNameForUser = (userId: string) => {
    const user = users.value.find((user: any) => user._id === userId);
    return user ? `${user.firstName} ${user.lastName}` : '';
};

onMounted( async () => {
    await getAllUsers();
    await getGlobalMessages();
}); 

</script>


<template>
    <div>
        <div class="surface-section">
            <div class="flex align-items-start flex-column lg:justify-content-between lg:flex-row mb-3">
                <div>
                    <div class="flex align-items-center text-700 flex-wrap">
                    </div>
                </div>
                <div class="mt-3 lg:mt-0">
                    <Button severity="success" label="Add New" class="p-button-outlined mr-2" @click="router.push({ name: 'EditGlobalMessage', params: { id: 'new' } })">
                        <template #icon>
                            <font-awesome-icon :icon="['fas', 'plus']" />&nbsp;
                        </template>
                    </Button>
                </div>
            </div>
        </div>

        <DataTable :value="globalMessages" dataKey="id" paginator :rows="10">
                <Column field="title" header="Title"></Column>
                <Column field="type" header="Type"></Column>
                <Column field="activeFrom" header="Active From">
                    <template #body="slotProps">
                        {{ new Date(slotProps.data.activeFrom).toLocaleString() }}
                    </template>
                </Column>
                <Column field="activeTo" header="Active To">
                    <template #body="slotProps">
                        {{ new Date(slotProps.data.activeTo).toLocaleString() }}
                    </template>
                </Column>
                <Column header="Aktionen">
                    <template #body="slotProps">
                        <Button class="p-button-tuev mr-2" @click="showUsers(slotProps.data.acknowledgedBy)">
                            <template #icon>
                                <font-awesome-icon :icon="['fas', 'users']" />
                            </template>
                        </Button>
                        <Button @click="router.push({ name: 'EditGlobalMessage', params: { id: slotProps.data._id } })" class="p-button-tuev">
                            <template #icon>
                                <font-awesome-icon :icon="['fas', 'edit']" />
                            </template>
                        </Button>
                    </template>
                </Column>
            </DataTable>

            <Dialog v-model:visible="showUsersDialog" modal header="Acknowledged By" :style="{ width: '40rem' }">
                <div class="p-d-flex p-flex-column p-4">
                    <DataTable :value="acknowledgedBy" dataKey="_id">
                        <Column field="userId" header="User">
                            <template #body="slotProps">
                                {{ getNameForUser(slotProps.data.userId) }}
                            </template>
                        </Column>
                        <Column field="timestamp" header="Acknowledged At">
                            <template #body="slotProps">
                                {{ new Date(slotProps.data.timestamp).toLocaleString() }}
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </Dialog>
    </div>
</template>